module.exports = __webpack_public_path__ + "img/sequence.43bf38ea.png";